(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_collection-callout"] && !Shopify.designMode) return;
  try {
    // Grid tile videos autoplay muted; visitors who turn motion off get the
  // poster instead (the CSS hides the video, this stops it downloading and playing).
  (() => {
    const query = window.matchMedia('(prefers-reduced-motion: reduce)');
    const apply = () => {
      for (const video of document.querySelectorAll('video.vx-tile__video')) {
        if (query.matches) {
          video.removeAttribute('autoplay');
          video.pause();
        } else if (video.paused) {
          video.play().catch(() => {});
        }
      }
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', apply, { once: true });
    } else {
      apply();
    }
    query.addEventListener('change', apply);
  })();
  } catch(e) { console.error(e); }
})();

})();
